import React, { useEffect } from 'react';
import { createBrowserRouter, RouterProvider, Outlet, useLocation } from 'react-router-dom';
import './i18n';
import './App.css';
import './theme/themes.css';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import TariffsPage from './pages/TariffsPage';
import Auto from './pages/Auto';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import { LanguageProvider } from './contexts/LanguageContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ConsentBanner from './components/ConsentBanner';
import { init as analyticsInit, trackPageview } from './analytics/analytics';
import { startWebVitals } from './analytics/perf';

function AppShell() {
    const location = useLocation();

    useEffect(() => {
        analyticsInit();
        startWebVitals();
    }, []);

    useEffect(() => {
        // Track SPA navigation
        trackPageview(location.pathname + location.search);
    }, [location.pathname, location.search]);

    return (
        <div className="App">
            <Header />
            <Outlet />
            <Footer />
            <WhatsAppButton />
            <ConsentBanner />
        </div>
    );
}

const router = createBrowserRouter([
    {
        path: '/',
        element: <AppShell />,
        children: [
            { index: true, element: <Home /> },
            { path: 'auto', element: <Auto /> },
            { path: 'tarieven', element: <TariffsPage /> },
            { path: 'privacy', element: <Privacy /> },
            { path: '*', element: <NotFound /> },
        ],
    },
]);

function App() {
    return (
        <ThemeProvider>
            <LanguageProvider>
                <RouterProvider router={router} future={{ v7_startTransition: true }} />
            </LanguageProvider>
        </ThemeProvider>
    );
}

export { AppShell };
export default App;